// composables/useDebouncedRef.ts
import { ref, watch } from 'vue';

export function useDebouncedRef<T>(
  initialValue: T,
  delay = 500,
  callback: (val: T) => void
) {
  const inputRef = ref<T>(initialValue);
  let timeout: ReturnType<typeof setTimeout>;

  watch(inputRef, (newVal: any) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      callback(newVal);
    }, delay);
  });

  return inputRef;
}
